export const rideTrackData =
{
  header: [
    {
      label: 'ID',
      key: 'id',
    },
    {
      label: 'Customer',
      key: 'customer',
    },
    {
      label: 'Ride Type',
      key: 'rideType',
    },
    {
      label: 'Driver Name',
      key: 'driverName',
    },
    {
      label: 'Pick up',
      key: 'pickup',
    },
    {
      label: 'Dropping',
      key: 'dropping',
    },
    {
      label: 'Car',
      key: 'car',
    },
    {
      label: 'Amount',
      key: 'amt',
    },
    {
      label: 'Status',
      key: 'status',
    },
  ],
  body: [
    {
      id: '3899499',
      customer: 'Danu .RY',
      rideType: 'One way Ride',
      driverName: 'John',
      pickup: 'Gopalan mall Bannerghatta Road ',
      dropping: 'Gopalan mall Bannerghatta Road ',
      amt: '₹1,89,774',
      status: 'Active',
      pickupDate: '23 June 2023 . 10 PM ',
      car: 'Maruti 800',
      carNumber: 'KA 75858'
    },
  ],
}
export const data = [
  {
    date: '12 June 2023',
    description: 'Taxi For One Trip',
    charges: '₹1,74',
    tax: '20%',
    amount: '₹200',
  },
  {
    date: '12 June 2023',
    description: 'Waiting Charge',
    charges: '₹25',
    tax: '20%',
    amount: '₹30',
  },
];



export const filterRideTrackdata = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value:'completed', list: 'Completed', key: 'Status' },
      { value:'booked', list: 'Booked', key: 'Status' },
      { value:'accepted', list: 'Accepted', key: 'Status' },
      { value:'cancelled', list: 'Cancelled', key: 'Status' },
      { value:'onGoing', list: 'OnGoing', key: 'Status' },
      { value:'dispatched', list: 'Dispatched', key: 'Status' }
    ]
  }
];

export const filterRevenueData = [
  {
    id: 1,
    primaryText: 'Duty Type',
    subItems: [
      { value:'airportTransfer', list: 'Airport Transfer', key: 'Status' },
      { value:'outstation', list: 'Outstation', key: 'Status' },
      { value:'rental', list: 'Rental', key: 'Status' }
    ]
  }
];

export const getStatusUpdateOptions = (status) => {
  switch (status?.toLowerCase()) {
    case 'ongoing':
      return [
        { id: 1, name: 'Update Status' }
      ];
    case 'closed':
      return [
        { id: 1, name: 'Update Status' }
      ];
    default:
      return []; // No menu options for other statuses
  }
};

export const tripStatusUpdateForm = (currentStatus) => {
  // Base options that are always available
  const baseOptions = [];
  
  // Add status options based on current status
  switch (currentStatus?.toLowerCase()) {
    case 'ongoing':
      baseOptions.push(
        { value: "Closed", label: "Closed" },
        { value: "Completed", label: "Completed" }
      );
      break;
    case 'closed':
      baseOptions.push(
        { value: "Completed", label: "Completed" }
      );
      break;
  }

  return [
    {
      id: 1,
      type: "select",
      label: "Status",
      name: "status",
      placeholder: "Select Status",
      required: true,
      options: baseOptions
    },
    {
      id: 2,
      type: "text",
      label: "Reason",
      name: "reason",
      placeholder: "Enter reason for status change",
      required: false
    }
  ];
};

export const moreIconActions = [
  {
    id: 1,
    name: "Update Status"
  }
];
